import { Button, Card, List, Modal } from 'antd';
import React, { useState } from 'react';
import { SKW_PREFIX } from '../../../../utils/constants';
import Swal from 'sweetalert2';
import api from '../../../../service/api';
import { ApplicationState } from '../../../../store';
import { useSelector } from 'react-redux';
import { RowLine, SpanBlock } from './styles';
import mask from '../../../../utils/mask';

export interface Props {
  record: any;
}

interface DataType {
  codProduto: number;
  descricaoProduto: string;
  quantidade: number;
  volume: string;
  pesoBruto: number;
  valorTotal: number;
}

const App: React.FC<Props> = ({ record }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const [nota, setNota] = useState<DataType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const showModal = () => {
    setLoading(true);
    setIsModalOpen(true);
    api
      .post(
        `call?serviceName=${SKW_PREFIX}getItensNota&pagina=${0}&tamanhoPagina=${50}&token=${token}`,
        {
          nuNota: record?.nfNumNota,
        }
      )
      .then((res) => {
        setNota(res.data?.itensNota);
      })
      .catch((err: any) => {
        Swal.fire({
          title: 'Ops...',
          text: 'Erro ao buscar os produtos da nota',
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button type="link" onClick={showModal}>
        {record?.nfNumNota}
      </Button>

      <Modal title="Itens da nota" visible={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        <List
          grid={{ gutter: 16, column: 1 }}
          loading={loading}
          pagination={false}
          dataSource={nota}
          renderItem={(item) => (
            <List.Item>
              <Card title={<span style={{ textAlign: 'center' }}></span>}>
                <RowLine>
                  <p>
                    <strong>Código produto</strong> <SpanBlock>{item.codProduto}</SpanBlock>
                  </p>
                  <p>
                    <strong>Produto</strong>{' '}
                    <SpanBlock>{mask('camelCase', item.descricaoProduto)}</SpanBlock>
                  </p>
                </RowLine>

                <RowLine>
                  <p>
                    <strong>Peso bruto</strong> <SpanBlock>{item.pesoBruto} KG</SpanBlock>
                  </p>
                  <p>
                    <strong>Valor total</strong>{' '}
                    <SpanBlock>{mask('currency', item.valorTotal)}</SpanBlock>
                  </p>
                </RowLine>
                <RowLine>
                  <p>
                    <strong>Quantidade</strong> <SpanBlock>{item.quantidade}</SpanBlock>
                  </p>
                  <p>
                    <strong>Unidade</strong> <SpanBlock>{mask('camelCase', item.volume)}</SpanBlock>
                  </p>
                </RowLine>
              </Card>
            </List.Item>
          )}
        />
      </Modal>
    </>
  );
};

export default App;
